import { useNavigate } from 'react-router-dom';
import { courseIncludes } from '../../../mocks/courseModules';

export default function FinalCTASection() {
  const navigate = useNavigate();

  const handleCheckoutClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'AddToCart', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
    }
    window.open('https://pay.hotmart.com/W100719375C?checkoutMode=10&bid=1774715641981', '_blank', 'noopener,noreferrer');
    navigate('/obrigado');
  };

  return (
    <section id="inscricao" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-orange-200 relative">
            <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-center py-3 text-sm font-bold tracking-wide">
              <i className="ri-flashlight-fill mr-1"></i>
              OFERTA ESPECIAL — VAGAS LIMITADAS COM ESTE VALOR
            </div>

            <div className="pt-16 p-8 lg:p-12">
              <div className="text-center mb-10">
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
                  Comece sua transformação agora
                </h2>
                <p className="text-gray-600 text-lg">
                  Tudo o que você precisa para dominar a IA na educação, por um valor acessível
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                {courseIncludes.map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-lg flex-shrink-0"></i>
                    <span className="text-sm text-gray-700">{item.text}</span>
                  </div>
                ))}
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 text-center border border-orange-200">
                <p className="text-sm text-gray-500 mb-1">Investimento único</p>
                <div className="flex items-center justify-center gap-3 mb-2">
                  <span className="text-6xl font-bold text-gray-900">R$ 147,00</span>
                </div>
                <p className="text-sm text-gray-500 mb-8">Pagamento único — acesso vitalício</p>

                <button
                  onClick={handleCheckoutClick}
                  className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 animate-pulse cursor-pointer w-full mx-auto"
                >
                  <i className="ri-shopping-cart-2-fill text-xl flex-shrink-0"></i>
                  Garantir Minha Vaga Agora
                </button>

                {/* Selo de Garantia */}
                <div className="flex items-center justify-center mt-8">
                  <div className="flex items-center gap-3 bg-green-50 border-2 border-green-300 rounded-2xl px-4 py-4 w-full">
                    <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-green-100 border-2 border-green-400 rounded-full">
                      <i className="ri-shield-check-fill text-green-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div className="text-left min-w-0">
                      <p className="text-green-800 font-bold text-sm leading-tight">Garantia Incondicional de 15 Dias</p>
                      <p className="text-green-700 text-xs mt-1 leading-snug break-words">Não gostou? Devolvemos 100% do seu dinheiro, sem perguntas e sem burocracia.</p>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-center gap-6 mt-5 text-sm text-gray-500">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-shield-check-line text-green-500 w-4 h-4 flex items-center justify-center"></i>
                    Compra segura
                  </div>
                  <div className="flex items-center gap-1.5">
                    <i className="ri-lock-line text-green-500 w-4 h-4 flex items-center justify-center"></i>
                    Dados protegidos
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
